<template>
    <div id="news-list">
      <van-nav-bar
        :placeholder="true"
        :safe-area-inset-top="true"
        :fixed="true"
        title="资讯列表"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
        <template #right>
          <van-icon  @click="search" name="search" size="24" />
        </template>
      </van-nav-bar>
      <empty v-if="newsList.length === 0"></empty>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="getInitData"
      >
        <news-item v-bind:newsInfo="newsList"></news-item>
      </van-list>
      <bottom-nav></bottom-nav>
    </div>
</template>

<script>
import BottomNav from './components/BottomNav';
import NewsItem from './components/NewsItem';
import { Empty } from '@/components';
export default {
  name: 'PreschoolNewsList',
  components: { BottomNav, NewsItem, Empty },
  data () {
    return {
      newsList: [], // 资讯列表
      finished: false,
      loading: false,
      pageNo: 1
    };
  },
  mounted () {
    // this.getInitData();
  },
  methods: {
    search () {
      this.$router.push({ name: 'PreschoolSearch' });
    },
    onClickLeft () {
      history.back();
    },
    getInitData () {
      const { $http } = this;
      let params = {
        pageNo: this.pageNo,
        consultType: 19
      };
      $http.get('search/consult', { params }).then((res) => {
        this.loading = false;
        this.finished = !res.data.isHasNext;
        this.pageNo = res.data.nextPage;
        this.newsList = res.data.result;
        console.log('资讯返回数据', res);
      });
    }
  }
};
</script>

<style scoped>

</style>